// @flow strict

import styled from 'styled-components';
import { StyledTypography } from '../Typography/Typography';

export const RawStyledHeadline5 = styled(StyledTypography)``;
export const StyledHeadline5 = RawStyledHeadline5;
